import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=dfe0189a&scoped=true"
import script from "./addOrEdit.vue?vue&type=script&lang=js"
export * from "./addOrEdit.vue?vue&type=script&lang=js"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=dfe0189a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe0189a",
  null
  
)

export default component.exports